import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { Alert, DatePicker, Form, FormInstance, Input } from "antd";
import { CreatePatientPayload } from "@/api/patients";
import useFormAutoFocusInput from "@/hooks/useFormAutoFocusInput";

dayjs.extend(weekday);
dayjs.extend(localeData);

interface PatientFormProps {
  form: FormInstance<CreatePatientPayload>;
  handleSubmit: (values: CreatePatientPayload) => void;
  error: string;
}

const PatientForm = ({ form, handleSubmit, error }: PatientFormProps) => {
  const { t } = useTranslation();
  const focusInputRef = useFormAutoFocusInput();

  return (
    <Form requiredMark={false} form={form} onFinish={handleSubmit}>
      <Form.Item label={t("Ім'я.firstName")} style={{ marginBottom: 0 }}>
        <Form.Item
          rules={[
            {
              required: true,
              message: t("Введіть ім'я") as string,
            },
          ]}
          name="firstName"
          style={{ display: "inline-block", width: "calc(40% - 8px)" }}
        >
          <Input
            ref={focusInputRef}
            placeholder={t("Введіть значення") as string}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: t("Введіть ім'я") as string,
            },
          ]}
          name="lastName"
          label={t("Last name")}
          style={{
            display: "inline-block",
            width: "60%",
            marginLeft: 8,
          }}
        >
          <Input placeholder={t("Введіть значення") as string} />
        </Form.Item>
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("Введіть дату") as string,
          },
        ]}
        name="birthDate"
        label={t("Дата народження")}
      >
        <DatePicker
          format="DD.MM.YYYY"
          placeholder={t("Виберіть дату") as string}
        />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("Введіть e-mail") as string,
          },
        ]}
        required
        name="mail"
        label="E-mail"
      >
        <Input placeholder={t("Введіть значення") as string} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: "Введіть номер телефону",
          },
        ]}
        required
        name="phone"
        label={t("Телефон")}
      >
        <Input required placeholder={t("Введіть значення") as string} />
      </Form.Item>

      {!!error && <Alert message={error} type="error" />}
    </Form>
  );
};

export default PatientForm;
